import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import VenueCard from "../components/VenueCard";
import VenueMap from "../components/VenueMap";
import FilterBar from "../components/FilterBar";
import { List, MapPin, SlidersHorizontal } from "lucide-react";

export default function Discover() {
  const { t } = useTranslation();
  const [venues, setVenues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("map");
  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    setLoading(true);
    const params = {};
    Object.keys(filters).forEach((k) => {
      if (filters[k] !== "" && filters[k] !== null && filters[k] !== undefined) params[k] = filters[k];
    });
    api.listVenues(params).then((data) => {
      setVenues(data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [filters]);

  const reset = () => setFilters({});

  return (
    <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8" data-testid="discover-page">
      <header className="mb-8">
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#FEBA01]">{t("discover.eyebrow")}</div>
        <h1 className="mt-1 font-display text-5xl sm:text-6xl uppercase tracking-tighter leading-none">{t("discover.title")}</h1>
        <p className="mt-3 text-[#A3A3A3] max-w-2xl">{t("discover.desc")}</p>
      </header>

      <div className="flex items-center justify-between mb-4 gap-2">
        <button
          onClick={() => setShowFilters((v) => !v)}
          className="lg:hidden inline-flex items-center gap-2 px-3 py-2 border-2 border-[#333] text-[#F5F5F5] font-mono uppercase text-xs tracking-widest"
          data-testid="discover-filters-toggle"
        >
          <SlidersHorizontal size={14} /> {t("discover.filters")}
        </button>
        <div className="ml-auto inline-flex border-2 border-[#333]">
          <button
            onClick={() => setView("list")}
            className={`px-6 py-3.5 font-mono text-base uppercase tracking-widest flex items-center gap-2.5 ${
              view === "list" ? "bg-[#FEBA01] text-black" : "text-[#F5F5F5]"
            }`}
            data-testid="view-list"
          >
            <List size={20} /> {t("discover.list")}
          </button>
          <button
            onClick={() => setView("map")}
            className={`px-6 py-3.5 font-mono text-base uppercase tracking-widest flex items-center gap-2.5 ${
              view === "map" ? "bg-[#FEBA01] text-black" : "text-[#F5F5F5]"
            }`}
            data-testid="view-map"
          >
            <MapPin size={20} /> {t("discover.map")}
          </button>
        </div>
      </div>

      <div className="grid lg:grid-cols-[320px_1fr] gap-6">
        <aside className={`${showFilters ? "block" : "hidden"} lg:block`}>
          <FilterBar filters={filters} setFilters={setFilters} onReset={reset} />
          <div className="mt-3 font-mono text-[10px] uppercase tracking-widest text-[#A3A3A3]" data-testid="results-count">
            {loading ? t("discover.loading") : t("discover.result", { count: venues.length })}
          </div>
        </aside>

        <main>
          {loading && (
            <div className="space-y-3">
              <div className="beer-pour" />
              <div className="text-[#A3A3A3] font-mono text-xs uppercase tracking-widest">{t("discover.pouring")}</div>
            </div>
          )}
          {!loading && view === "list" && (
            <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="venues-grid">
              {venues.map((v) => (
                <VenueCard key={v.id} venue={v} />
              ))}
              {venues.length === 0 && (
                <div className="col-span-full p-10 text-center border-2 border-dashed border-[#333] text-[#A3A3A3] font-mono uppercase text-sm tracking-widest">
                  {t("discover.noResults")}
                </div>
              )}
            </div>
          )}
          {!loading && view === "map" && (
            <VenueMap venues={venues} height={600} />
          )}
        </main>
      </div>
    </div>
  );
}
